import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Formik, ErrorMessage } from "formik";
import { useStyles } from "./styles";
import useLend from "../../../../Hooks/lend";
import Loader from "../../../../common/Loader";
import * as yup from "yup";
import moment from "moment";
import useAuthStore from "../../../../Hooks/auth";

const current = moment(new Date()).format("YYYY");

const lendBooksSchema = yup.object().shape({
  idLibraryBook: yup.string().required("* Please enter the book title"),
  regNumber: yup.string().required("* Please enter the register number"),
  lendDate: yup.string().required("* Please select lend date"),
  dueDate: yup.string().required("* Please select the due date"),
});

const LendBooks = () => {
  const {
    addLendBooksInfo,
    getBooksTitleInfo,
    getStudentInfo,
    bookTitle,
    studentList,
    loading,
  } = useLend();
  const classes = useStyles();
  const [hide, setHide] = useState(false);
  const [show, setShow] = useState(false);
  const{institutionId}=useAuthStore();

  const initialValue = {
    idLibraryBook: "",
    regNumber: "",
    lendDate: "",
    dueDate: "",
    id: "",
  };

  const searchTitle = (values) => {
    if (values.length !== 0) {
      setHide(true);
    } else {
      setHide(false);
    }
  };

  const searchStudent = (values) => {
    if (values.length !== 0) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Stack>
          <Box>
            <Paper
              sx={{
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
              className={classes.listMenu}
            >
              <Stack sx={{ p: 4 }}>
                <Typography sx={{ py: 2 }} className={classes.add_course_text}>
                  Lend Books
                </Typography>
                <Grid container>
                  <Grid item lg={11} xl={10} sm={12}>
                    <Stack>
                      <Formik
                        validationSchema={lendBooksSchema}
                        initialValues={initialValue}
                        validateOnBlur={false}
                        validateOnChange={false}
                        onSubmit={(values) => {
                          addLendBooksInfo(values);
                        }}
                      >
                        {(formik) => {
                          const {
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            values,
                            setFieldValue,
                          } = formik;
                          return (
                            <form onSubmit={handleSubmit}>
                              <Grid
                                container
                                sx={{ py: 2 }}
                                className={classes.form_add_course}
                                spacing={4}
                              >
                                <Grid item md={6} sx={{ width: "100%" }}>
                                  <Stack
                                    md={5}
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 1 }}
                                      >
                                        Book Title
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{
                                          width: 230,
                                        }}
                                        id="idLibraryBook"
                                        name="idLibraryBook"
                                        placeholder="Enter title"
                                        autoComplete="off"
                                        className={
                                          errors.idLibraryBook &&
                                          touched.idLibraryBook
                                            ? classes.inputError
                                            : classes.inputNoError
                                        }
                                        onBlur={handleBlur}
                                        onChange={(e,) => {
                                          handleChange(e);
                                          searchTitle(e.target.value);
                                          getBooksTitleInfo({title:e.target.value,institutionId:institutionId});
                                          
                                        }}
                                        value={values.idLibraryBook}
                                      />
                                      <ErrorMessage
                                        name="idLibraryBook"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                  {hide ? (
                                    <List
                                      className={classes.booklist}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {bookTitle?.map((title, index) => {
                                        //console.log(title);
                                        return (
                                          <>
                                            <ListItem
                                              onClick={() => {
                                                setFieldValue(
                                                  "idLibraryBook",
                                                  title.title
                                                );
                                                setFieldValue("id", title.id);
                                                setHide(false);
                                              }}
                                            >
                                              {title.title}
                                            </ListItem>
                                          </>
                                        );
                                      })}
                                    </List>
                                  ) : (
                                    <Stack></Stack>
                                  )}
                                </Grid>
                                <Grid item md={6} sx={{ width: "100%" }}>
                                  <Stack
                                    md={5}
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack md={6}>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 5 }}
                                      >
                                        Register Number
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{ width: 230 }}
                                        id="regNumber"
                                        name="regNumber"
                                        placeholder="Enter register number"
                                        autoComplete="off"
                                        className={
                                          errors.regNumber && touched.regNumber
                                            ? classes.inputError
                                            : classes.inputNoError
                                        }
                                        onBlur={handleBlur}
                                        onChange={(e) => {
                                          searchStudent(e.target.value);
                                          handleChange(e);
                                          getStudentInfo({value:e.target.value,institutionId:institutionId});
                                        }}
                                        value={values.regNumber}
                                      />
                                      <ErrorMessage
                                        name="regNumber"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                  {show ? (
                                    <List
                                      className={classes.list}
                                      style={{ cursor: "pointer" }}
                                    >
                                      {studentList?.student?.map(
                                        (title, index) => {
                                          return (
                                            <ListItem
                                              key={index}
                                              onClick={() => {
                                                setFieldValue(
                                                  "regNumber",
                                                  title.regNumber
                                                );
                                                setShow(false);
                                              }}
                                            >
                                              {title.regNumber}
                                            </ListItem>
                                          );
                                        }
                                      )}
                                    </List>
                                  ) : (
                                    <Stack></Stack>
                                  )}
                                </Grid>
                              </Grid>
                              <Grid
                                container
                                sx={{ pb: 2 }}
                                className={classes.form_add_course}
                                spacing={4}
                              >
                                <Grid item md={6} sx={{ width: "100%" }}>
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack md={6}>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 1 }}
                                      >
                                        Lend Date
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{
                                          width: 230,
                                        }}
                                        id="lendDate"
                                        type="Date"
                                        name="lendDate"
                                        value={values.lendDate}
                                        className={
                                          errors.lendDate && touched.lendDate
                                            ? classes.inputError
                                            : classes.inputNoError
                                        }
                                        onChange={handleChange}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                      />
                                      <ErrorMessage
                                        name="lendDate"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                </Grid>
                                <Grid item md={6} sx={{ width: "100%" }}>
                                  <Stack
                                    sx={{
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Stack>
                                      <Typography
                                        className={classes.label}
                                        sx={{ pr: 8 }}
                                      >
                                        Due Date
                                      </Typography>
                                    </Stack>
                                    <Stack>
                                      <TextField
                                        sx={{
                                          width: 230,
                                        }}
                                        id="dueDate"
                                        type="date"
                                        name="dueDate"
                                        value={values.dueDate}
                                        className={
                                          errors.dueDate && touched.dueDate
                                            ? classes.inputError
                                            : classes.inputNoError
                                        }
                                        onChange={handleChange}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        placeholder="Enter Due Date"
                                      />
                                      <ErrorMessage
                                        name="dueDate"
                                        component="span"
                                        className={classes.error}
                                      />
                                    </Stack>
                                  </Stack>
                                </Grid>
                              </Grid>
                              <Grid item md={12}>
                                <Stack
                                  sx={{
                                    flexDirection: "row",
                                    justifyContent: "end",
                                  }}
                                >
                                  <Button
                                    type="submit"
                                    sx={{ borderRadius: "50px" }}
                                    className={classes.addLend}
                                  >
                                    Lend
                                  </Button>
                                </Stack>
                              </Grid>
                            </form>
                          );
                        }}
                      </Formik>
                    </Stack>
                  </Grid>
                </Grid>
              </Stack>
            </Paper>
          </Box>
        </Stack>
      )}
    </>
  );
};

export default LendBooks;
